import { compressImageFile } from './compressImageFile.js';
import { useI18n } from 'vue-i18n';
import { useToast } from 'primevue/usetoast';
import axios from 'axios';

export function useImageUpload() {
    const toast = useToast();
    const { t } = useI18n({ useScope: 'global' });

    const MAX_FILE_SIZE = 5 * 1024 * 1024;
    const ACCESSED_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];

    const uploadImage = async (file) => {
        const compressedImage = await compressImageFile(file);
        const formData = new FormData();
        formData.append('file', compressedImage);

        try {
            const { data } = await axios.post('https://proctoring-api.univora.uz/services/platon-core/web/v1/public/files/upload/category/option_image', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return data.id;
        } catch (error) {
            console.error('Image upload failed:', error);
            throw error;
        }
    };

    const uploadImageHandler = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > MAX_FILE_SIZE) {
            return toast.add({ severity: 'warn', summary: t('uploadAvatar.accessed-size-image-warning-message', { val: 5 }), life: 3000 });
        }
        if (!ACCESSED_TYPES.includes(file.type)) {
            return toast.add({ severity: 'warn', summary: t('uploadAvatar.accessed-types-image-warning-message'), life: 3000 });
        }

        try {
            const id = await uploadImage(file);
            return id;
        } catch (error) {
            toast.add({ severity: 'error', summary: t('uploadAvatar.upload-error-message'), life: 3000 });
        }
    };
    return {
        uploadImageHandler,
    };
}
